import { getToken } from '../user/tokens'
import axios from 'axios'
import { axiosWithKey } from "~/axios";
import _ from 'lodash'

export function getVideo(id, cb) {
  return getToken().then(token => {
    return axios
      .get(
        `${window.settings.apiBaseUrl}/entitlement/video/status?id=${id}`,
        {
          headers: {
            Authorization: token
          },
          withCredentials: true
        }
      )
      .then(res => {
        return cb(res);
      })
      .catch(err => {
        throw err.response.data;
      });
  })
}

export function getVideoSignature(id) {
  return getToken().then(token =>
    axios({
      url: `/signature/entitlement`,
      baseURL: window.settings.apiBaseUrl,
      params: { site: window.settings.internalName,id: id },
      method: "GET",
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
      withCredentials: true
    }).then(response => {})
  );
}

export function getFilteredContent(contentType, chosenTags, conceptName, filterOffset, setFilterLimit, sortByParameter, filterFieldName, filterFieldVal) {
  return getToken().then( token => {

    let queryString = null;

    var contentApiHeaders = {
      Authorization: token
    }

    if(!_.isEmpty(chosenTags)) {
      const chosenTagsQuery = _.merge({}, chosenTags);
    
      Object.keys(chosenTagsQuery).map((key) => {
        if(chosenTagsQuery[key].length == 0) {
          delete chosenTagsQuery[key];
        } else {
          (chosenTagsQuery[key]).map((key1) => {key1.replace(/ /g, "+")})
        }
      })
      queryString = Object.keys(chosenTagsQuery)
        .map(key => (((chosenTagsQuery[key] == 'Filter Out') ? false : chosenTagsQuery[key]))).join('::')
    }

    return axios
      .get(`${window.settings.apiBaseUrl}/search/v2/list`, {
        params: {
          site: window.settings.internalName,
          type: contentType,
          field: filterFieldName,
          value: filterFieldVal,
          concepts: conceptName,
          tagNames: queryString,
          languageCode: 'default',
          maxTotal: true,
          limit: (setFilterLimit == true) ? 20 : null,
          offset: filterOffset || 0,
          sortBy: sortByParameter || 'updateDate'
        },
        requestId: "search",
        headers: contentApiHeaders
      })
      .catch(function(thrown) {
        if (axios.isCancel(thrown))
          console.log("Request canceled", thrown.message);
      });
    }).then(res => {
      console.log(res.data)
      return res && res.data
    })
};

export function getSearchedVideos(contentType, filterFieldName, filterFieldVal, filterOffset, setFilterLimit, episodeId) {
  return axios
  .get(`${window.settings.apiBaseUrl}/search/v2/list`, {
    params: {
      site: window.settings.internalName,
      type: contentType,
      field: filterFieldName,
      value: filterFieldVal,
      languageCode: 'default',
      limit: (setFilterLimit == true) ? 20 : null,
      offset: filterOffset || 0,
      episodeId: episodeId || null
    },
    requestId: "search"
  })
  .then(res=>{
    return res && res.data;
  })
  .catch(function(thrown) {
    if (axios.isCancel(thrown))
      console.log("Request canceled", thrown.message);
  });
}

export const fetchConcepts = () =>
  new Promise((resolve, reject) => {
    const { internalName } = window.settings;
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `content/categories?site=${internalName}&languageCode=default`,
        headers: { Authorization: token }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  });
